import React from 'react';
import { Flex, Button } from '@opendoor/bricks/core';
import { MarginProps } from '@opendoor/bricks/system/theme';
import { A11yProps } from '@opendoor/bricks/system/a11y.types';

type SaveButtonProps = {
  disabled?: boolean;
  formName?: string;
  hideCancel?: boolean;
  loading?: boolean;
  onCancel?: () => void;
  onClick: () => void;
  analyticsPrefix?: string;
  containerProps?: MarginProps;
} & A11yProps<'button'>;

/**
 * Renders save / cancel buttons for closing forms.
 *
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const SaveButton: React.FC<SaveButtonProps> = ({
  disabled,
  hideCancel,
  loading,
  onCancel,
  onClick,
  analyticsPrefix,
  containerProps,
  ...props
}) => (
  <Flex flexDirection={['column', null, 'row']} {...containerProps}>
    <Button
      data-testid={`${analyticsPrefix ?? ''}save`}
      analyticsName={`cake-${analyticsPrefix ?? ''}save`}
      disabled={disabled || loading}
      loading={loading}
      onClick={onClick}
      maxWidth={['100%', null, '327px']}
      {...props}
    >
      Save and close
    </Button>
    {onCancel && !hideCancel && (
      <Button
        mt={[4, null, 0]}
        ml={[0, null, 4]}
        aria-label="Cancel form"
        analyticsName={`cake-${analyticsPrefix ?? ''}cancel`}
        data-testid={`${analyticsPrefix ?? ''}cancel`}
        variant="secondary"
        onClick={onCancel}
        disabled={loading}
      >
        Cancel
      </Button>
    )}
  </Flex>
);
